import styled from 'styled-components'

// Components
import Form from 'components/Form'

export const StyledFormField = styled(Form.Field)`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
`
